<template>
	<div class="dashboard-widget dashboard-widget-alerts">
		<div class="header">
			<svgicon name="alert" :fill="false"/>
			<h2>{{ $t('base.general.alerts') }}</h2>
		</div>
		<div class="body">
			<div class="alerts-container">
				<div class="swiper-container swiper-container-alerts">
					<div class="swiper-wrapper">
						<alerts-widget-alert v-for="alert in alerts" :key="alert.id" :alert="alert" class="swiper-slide alert"/>
						<see-all-alerts v-if="matches" :user_uid="user_uid" :alerts_length="alerts.length" class="swiper-slide"/>
					</div>
					<div v-if="alerts.length" class="swiper-pagination"></div>
				</div>
				<see-all-alerts v-if="!matches" :user_uid="user_uid" :alerts_length="alerts.length"/>
			</div>
		</div>
	</div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { Swiper, Pagination, Mousewheel } from 'swiper/dist/js/swiper.esm.js'
import AlertsWidgetAlert from './components/AlertsWidgetAlert'
import SeeAllAlerts from './components/SeeAllAlerts'
Swiper.use([ Pagination, Mousewheel ]);
export default {
	components: {
		AlertsWidgetAlert,
		SeeAllAlerts
	},
	props: [
		'user_uid',
		'alerts'
	],
	data () {
		return {
			swiper: null,
			breakpoint: null,
			matches: null
		}
	},
	watch: {
		alerts: {
			handler () {
				this.$nextTick(function () {
					this.swiper = new Swiper('.swiper-container-alerts', {
						observer: true,
						slidesPerView: 3,
						spaceBetween: 10,
						mousewheel: true,
						breakpoints: {
							1025: {
								slidesPerView: 1,
								spaceBetween: 10
							},
							1275: {
								slidesPerView: 2,
								spaceBetween: 10
							}
						},
						pagination: {
							el: '.swiper-pagination',
							type: 'bullets',
							clickable: true,
						}
					})

					this.breakpoint = window.matchMedia('(max-width: 1025px)')
					this.matches = this.breakpoint.matches
					this.breakpoint.addListener(this.breakpointChecker)
				})
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		breakpointChecker () {
			if (this.breakpoint.matches === true) {
				this.matches = true
			} else if (this.breakpoint.matches === false) {
				this.matches = false
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/AlertsWidget.vue